import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
    "@global": {
        "@keyframes shake" :{
            "0%": { transform: "translate(1px, 1px) rotate(0deg)" },
            "10%" :{ transform: "translate(-1px, -2px) rotate(-1deg) "},
            "20%" :{ transform: "translate(-1px, 0px) rotate(1deg)" },
            "30%": { transform: "translate(1px, 1px) rotate(0deg)" },
            "40%": { transform:" translate(1px, -1px) rotate(1deg)" },
            "50%": { transform: "translate(-1px, 1px) rotate(-1deg)" },
            "60%": { transform: "translate(-1px, 1px) rotate(0deg) "},
            "70%": { transform: "translate(1px, 1px) rotate(-1deg)" },
            "80%": { transform:" translate(-1px, -1px) rotate(1deg) "},
            "90%": { transform:" translate(1px, 1px) rotate(0deg) "},
            "100%": { transform: "translate(1px, -1px) rotate(-1deg)" }
      
          }
      },
  appBar:{
  
 // backgroundColor:theme.palette.background.default,
  color:theme.palette.secondary.main
 

  }
,  
    badge:{
        marginLeft:"10px",
        marginRight:"10px",
        fontSize:35,
        animation: "fadeIn .2s ease-in-out" ,
       

        '&:hover': {
           // color: "gray",
           fontSize: 40,
           animation: "shake 0.5s",
          
           
           /* When the animation is finished, start again */
           animationIterationCount: "1",
           
         
          
        },
        [theme.breakpoints.between('xs', 'md')]: {
            fontSize:20,
          
          },
    },
    notiIcon:{
        fontSize:35,
      
      
        [theme.breakpoints.between('xs', 'md')]: {
            fontSize:25,
          
          },
    },
    icon:{
 
     fontSize:35,

margin:"10% 10%",
     animation: "fadeIn .2s ease-in-out" ,

    //  '&:hover': {
    //     // color: "gray",
       
    //     transition: "all 250ms ease-in-out",
    //     backgroundColor:theme.palette.secondary.light,
    //     borderRadius:"50%",
       
    //    // boxShadow: "0 0 0 3px"+theme.palette.secondary.main
    //     //transform: "rotate(360deg)",
       
    //  },
     [theme.breakpoints.between('xs', 'md')]: {
         fontSize:27,
       
       },
    },
    iconBox:{
      backgroundColor:theme.palette.background.paper,
      borderRadius:10,
      marginLeft:"10px",
      marginRight:"10px",
      height:"45px",
      width:"45px",
      [theme.breakpoints.between('xs', 'md')]: {
        height:"35px",
        width:"35px",
      
      },
      transition: "all 250ms ease-in-out",
        '&:hover': {
         color: "white",
    
        backgroundColor:theme.palette.secondary.main,
        borderRadius:"50%",
       
       // boxShadow: "0 0 0 3px"+theme.palette.secondary.main
        //transform: "rotate(360deg)",
       
     },
      
      
    },
    menuIcon:{
     
        fontSize:33,
        padding:"0 2px",
        margin:"10% 10%",
        animation: "fadeIn .2s ease-in-out" ,
        
   
        '&:hover': {
      
      
           transition: "all 250ms ease-in-out",
          //  backgroundColor:theme.palette.secondary.main,
          //  borderRadius:"50%",
           
          // boxShadow: "0 0 0 3px"+theme.palette.secondary.main
          
          
   
        }
        ,
        [theme.breakpoints.between('xs', 'md')]: {
            fontSize:27,
          
          },
    }
 
    
}));
